import styled from 'styled-components';
import { pickThemeFontSize, pickThemeFontStyles } from '@/theme';
import { Tag } from 'antd';

export const StyledTag = styled(Tag)<{ $primaryColor: string }>`
  ${pickThemeFontStyles('12', '12')};
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  display: inline-flex;
  gap: 0.25rem;
  align-items: center;

  & .anticon {
    font-size: ${pickThemeFontSize('14')};
  }
`;
